// yyyy-MM-dd
export const formatDate = (date, s) => {
  var d = date ? new Date(date) : new Date()
  var month = '' + (d.getMonth() + 1)
  var day = '' + d.getDate()
  var year = d.getFullYear()
  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day
  if (s) {
    return [year, month, day].join(s)
  } else {
    return [year, month, day].join('-')
  }
}
export const diffDays = (dateStr1, dataStr2) => {
  var date1 = new Date(dateStr1)
  var date2 = dataStr2 ? new Date(dataStr2) : new Date()
  var timeDiff = Math.abs(date2.getTime() - date1.getTime())
  var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
  return diffDays
}

export const formatDateTime = (date, s) => {
  var d = date ? new Date(date) : new Date()
  var hours = '' + d.getHours()
  var min = '' + d.getMinutes()
  var sec = '' + d.getSeconds()

  if (hours.length < 2) hours = '0' + hours
  if (min.length < 2) min = '0' + min
  if (sec.length < 2) sec = '0' + sec
  if (s) {
    return formatDate(d, s) + ' ' + [hours, min, sec].join(':')
  } else {
    return formatDate(d) + ' ' + [hours, min, sec].join(':')
  }
}
